module.exports = __webpack_public_path__ + "img/pic_161406.bd086487.jpg";